import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { menulist } from '../class/status';
import { page } from '../class/status';
import { environment } from '../../../environments/environment';
import { Rtable } from '../class/rtabledata';
import * as moment from 'moment';
import { Dep } from '../class/auth';
@Component({
  selector: 'app-ranklist',
  templateUrl: './ranklist.component.html',
  styleUrls: ['./ranklist.component.css']
})
export class RanklistComponent implements OnInit {  
  constructor(
    public httpClient: HttpClient,
  ){}

  ngOnInit(): void {
    this.init_time();
    this.preurl = environment.serverurl;
    this.urltoken = this.preurl+"/v1/common/export_ranking.php?limit=true&token="+Dep.token+"&time="+Date.now();
  }
  time :any={};
  time_info:any=-1;
  menu_list:menulist = [
    // {id:'0',name:'周排行'},
    // {id:'1',name:'月排行'},
    // {id:'2',name:'總排行'},
    {id:'0',name:'自選排行'},
    // {id:'1',name:'推薦排行'}
  ]
  gender_list:menulist = [{id:'1',name:'男生'},{id:'2',name:'女生'}]
  tool_obj = {gender:'2',vid:'-1'};
  search_model:string = '';
  data:any=[];
  loading:boolean=true;
  pageobj:page = {page:0,count:8,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj));
  sort_obj:any = {column:'total',sort:'0'}
  now:string = '0';
  preurl:string = '';
  urltoken:string = '';
  link:string = environment.link;
  v_list:any=[];
  timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 }, ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
   
  tcontent = [
                {title:'名稱',content:'name',type:2,css:'width: 10%;'},
                {title:'頭像',content:'profile_pic',type:1,css:'width: 10%;'},
                {title:'文字',content:'text',format:'number',css:'min-width: 80px;',sort:'text'},
                {title:'語音',content:'voice',format:'number',css:'min-width: 80px;',sort:'voice'},
                {title:'視訊',content:'video',format:'number',css:'min-width: 80px;',sort:'video'},
                {title:'動態',content:'album',format:'number',css:'min-width: 80px;',sort:'album'},
                {title:'禮物',content:'gift',format:'number',css:'min-width: 80px;',sort:'gift'},
                {title:'打賞',content:'donate',format:'number'},
                {title:'直播',content:'live',format:'number'},
                {title:'遊戲',content:'game',format:'number'},
                {title:'活動',content:'active',format:'number'},
                {title:'約會',content:'date',format:'number'},
                {title:'語音房',content:'voice_room',format:'number'},
                {title:'其他',content:'other',format:'number'},
                {title:'加總',content:'total',format:'number',css:'min-width: 80px;',sort:'total'},
            ];

  showDatePickersTatus = true;

  init_list(){ 
    this.loading = true;
    const body = {action:this.now,page: this.pageobj.page,count:this.pageobj.count,gender:this.tool_obj.gender,vid:this.tool_obj.vid,
      now_range:this.time,
      sort_obj:this.sort_obj,
      search:this.search_model,  
    };

    console.log('body',body);
    this.httpClient.post<any>("/v1/common/get_leadboard.php",body).subscribe(res => {
      this.loading = false;
     if(res.status){
        this.data = res.data;
        this.v_list = res.vlist;
        this.pageobj.total_count = res.total_count;
      }else{
        this.data = [];
        this.v_list = [];
        this.pageobj.total_count = 0;
        this.tool_obj.vid = '-1';
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      console.log('res',res);
    });
  }

  init_time(){
    let default_status = true;
    if(this.time_info!=-1){
        const tmp = this.time_info.split("_");
        if(tmp.length==4){
            default_status = false;
            this.time.start = tmp[0]
            this.time.end = tmp[1]


            this.time.startDate = moment(tmp[0]);
            this.time.endDate = moment(tmp[1]);

        }
    }

    if(default_status){
      this.time.startDate = moment().subtract(7, 'days');
      this.time.endDate = moment().subtract(0, 'days');
      this.time.start = moment(this.time.startDate)
      this.time.end = moment(this.time.endDate)
    }

    if(this.showDatePickersTatus){
        this.time.startDate = '';
        this.time.endDate = '';
        this.time.start = '';
        this.time.end = '';
    }

    this.init_list();  
}

  handlepage(e){
    this.pageobj.page = e;
    this.init_list();  
  }

  checkLt(item){
   console.log('item',item);
  } 

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  choose(id:string){
    this.now = id;
    this.init_list();
  }

  onRangeSelected(type,value: any) {
    if(value.startDate){
      this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
      this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
    }
  }


  handleRangeSelected( value: any ): void {
    
    let  eventDate = value.event;

    if(this.showDatePickersTatus){
        this.time.startDate = moment().subtract(7, 'days');
        this.time.endDate = moment().subtract(0, 'days');
        this.time.start = moment(this.time.startDate);
        this.time.end = moment(this.time.endDate);
    }else{
        this.time.startDate = '';
        this.time.endDate = '';
        this.time.start = '';
        this.time.end = '';
    }
  
    if(eventDate.startDate){
        this.time.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
        this.time.end =  moment(eventDate.endDate).format('YYYY-MM-DD')    
    }

    this.showDatePickersTatus = !this.showDatePickersTatus;
    this.init_list();
  }

  handlesortdata( value: any ): void {
    this.sort_obj = value;
    this.init_list();
  }

  sort_fn(key,can_sort=1){
    if(can_sort){
        if(key==this.sort_obj.column){
          this.sort_obj.sort = this.sort_obj.sort == '0'?'1':'0';
        }else{
          this.sort_obj.column = key;
          this.sort_obj.sort = '0';
        }
        this.init_list(); 
    }
}
 

}
